// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-with-text-block/image-with-text-block.component.scss
// module id = 560
// module chunks = 0